import React, { useState } from 'react';
import { gql } from '@apollo/client';
import IdInput from 'components/Filter/IdInput';
import { BooleanField, Datagrid, BooleanInput, DateInput, DateField } from 'react-admin';
import List from 'components/List';
import MarketInput from 'components/MarketInput';
import PositionInput from 'components/PositionInput';
import LinkField from 'components/LinkField';
import MoneyField from 'components/MoneyField';
import BlendedRateField from 'components/BlendedRateField';
import RateMarkupField from 'components/RateMarkupField';
import UsingBlendedRateField from '../../../components/UsingBlendedRateField';
import { getSettingsQuery } from '../utils/getSettingsQuery';
import { SettingsNestedOperatorSelect } from 'components/SettingsNestedOperatorSelect';

const MarketPositionRateSettingListFilters = [
  <IdInput />,
  <PositionInput emptyText="All" alwaysOn />,
  <MarketInput alwaysOn resettable />,
  <BooleanInput alwaysOn source="active" />,
  <BooleanInput label="Below State/State LT Rate" alwaysOn source="search.below_state_rate" />,
  <DateInput alwaysOn label="Last review after" source="search.last_rate_review_from" />,
];

const MarketPositionRateSettingList = () => {
  const [settingsNestedOperator, setSettingsNestedOperator] = useState('ten99');

  return (
    <List filters={MarketPositionRateSettingListFilters} exporter={false}>
      <SettingsNestedOperatorSelect
        setSettingsNestedOperator={setSettingsNestedOperator}
        settingsNestedOperator={settingsNestedOperator}
      />
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="Market" source="market.display_name" sortBy="market_name" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />

        <UsingBlendedRateField forceNestedObject={settingsNestedOperator} />
        <MoneyField
          label="Charge 8hr rate"
          source={`settings.${settingsNestedOperator}.charge_rate_cents`}
          blankIfNull={true}
          sortBy={`${settingsNestedOperator.replace('.', '_')}_charge_rate_cents`}
        />

        <RateMarkupField
          sortBy={`${settingsNestedOperator.replace('.', '_')}_blended_rate_markup`}
          hasBlendedRateMarkup={true}
          classification={settingsNestedOperator}
        />
        <BlendedRateField
          sortable={false}
          blankIfNull={true}
          classification={settingsNestedOperator}
        />

        <BooleanField source="active" />
        <DateField source="last_rate_review" />
      </Datagrid>
    </List>
  );
};

MarketPositionRateSettingList.query = gql`
  query marketPositionRateSettings($input: MarketPositionRateSettingQueryInput) {
    _marketPositionRateSettingsMeta(input: $input) {
      count
    }
    marketPositionRateSettings(input: $input) {
      id
      active
      last_rate_review
      market {
        id
        display_name
      }
      market_id
      market_position_rate_setting_active
      market_position_rate_setting_id
      position {
        id
        display_name
      }
      position_id
      ${getSettingsQuery()}
      specialty {
        id
        label
      }
      specialty_id
      state_position_rate_setting_active
      state_position_rate_setting_id
    }
  }
`;

export default MarketPositionRateSettingList;
